import { StyleSheet } from 'react-native';
import { Paprika } from './theme';

export const GlobalStyles = StyleSheet.create({
  centeredContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: Paprika.background,
  },
});
